import React, { Fragment } from 'react';
import { Divider } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import cn from 'classnames';

const useStyles = makeStyles(theme => ({
    divider: {
        marginTop: theme.spacing(4),
        marginBottom: theme.spacing(6),
    },
}));

/**
 *
 * @param {Object} props
 * @param {React.ReactNode} [props.children]
 * @param {import('@mui/material').DividerProps} [props.DividerProps]
 * @param {boolean} [props.noDefaultStyles]
 */
export default function SectionDividers(props) {
    const {
        children,
        noDefaultStyles = false,
        DividerProps: {
            className: propsClass,
            ...DividerProps
        } = {},
    } = props;

    const classes = useStyles(props);

    const filteredChildren = React.Children.toArray(children)
        // Skip false/null ONLY - this is how React does conditional rendering.
        .filter(c => c !== false && c !== null);

    return React.Children.map(filteredChildren, (child, index) => (
        <Fragment key={index}>
            {index > 0 && (
                <Divider
                    className={cn(!noDefaultStyles && classes.divider, propsClass)}
                    {...DividerProps}
                />
            )}

            {child}
        </Fragment>
    ));
}